import Select from 'react-select';
import PropTypes from 'prop-types'

const FieldSelect = ({
                         id,
                         placeholder,
                         iconBefore,
                         iconAfter,
                         wrapperClasses,
                         inputClasses,
                         selectProps,
                         options,
                         field,
                         onChange,
                         form: {touched, errors, setFieldValue}
                     }) => {
    return (
        <div className={"mb-6 " + wrapperClasses}>
            <div className="field input-group flex py-2 mb-2 shadow">
                {iconBefore &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                   {iconBefore}
                </span>
                }
                <div className="relative w-full">
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name={field.name}
                        value={field.value}
                        options={options}
                        styles={customStyles}
                        onChange={(selected) => {
                            setFieldValue(field.name, selected);
                            if (onChange) {
                                onChange(selected);
                            }
                        }}
                        theme={(theme) => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary25: 'rgba(150, 150, 150, 0.15)',
                                primary50: 'rgba(150, 150, 150, 0.25)',
                                primary: 'black',
                            },
                        })}
                        {...selectProps}
                    />
                </div>
                {iconAfter &&
                    <span
                        className="flex items-center justify-center text-gray-400	">
                   {iconAfter}
                </span>
                }

            </div>
            {touched[field.name] && errors[field.name] &&
                <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
            }
        </div>
    )
}

export default FieldSelect

FieldSelect.propTypes = {
    type: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    iconBefore: PropTypes.element,
    iconAfter: PropTypes.element,
    options: PropTypes.array,
    field: PropTypes.object,
    form: PropTypes.object,
    selectProps: PropTypes.any,
    wrapperClasses: PropTypes.string,
    inputClasses: PropTypes.string,
    onChange: PropTypes.func,
}

const customStyles = {
    container: (provided) => ({
        ...provided,
        paddingLeft: '0.25rem',
        paddingRight: '0.25rem',
    }),
    control: (provided) => ({
        ...provided,
        border: 'none',
        boxShadow: "none"
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    placeholder: (provided) => ({
        ...provided,
        fontStyle: "italic"
    })
}
